import EvalComEquipo from "pages/LandingPages/EvalComEquipo/evalComEquipo";

export default function EvalComEquipoPage() {
  return <EvalComEquipo />;
}
